export default {
  appointmentContainer: {
    title: 'Daños a la propiedad',
    solution: 'Solución:',
    text: 'Elegir un profesional autorizado por Allianz',
    text2: 'Fecha deseada para los trabajos',
    text3: 'Hora de paso deseada:',
    infoBox: 'Si los horarios no están disponibles o no son compatibles con sus disponibilidades, elija ser llamado para fijar la cita dentro de 48h*.',
    workHour: '*Horas hábiles y salvo problema excepcional o independiente de nuestra voluntad',
    actions: {
      primary: 'Confirmar cita',
      secondaryHelpText: '¿Ninguno de estas opciones es adecuado para ti?',
      secondary: 'Ser llamado para fijar una cita',
      ren: {
        primary: 'Validar el horario',
        tertiary: 'Elegir otra solución'
      }
    },
    dates: {
      months: {
        january: 'Enero',
        february: 'Febrero',
        march: 'Marzo',
        april: 'Abril',
        may: 'Mayo',
        june: 'Junio',
        july: 'Julio',
        august: 'Agosto',
        september: 'Septiembre',
        october: 'Octubre',
        november: 'Noviembre',
        december: 'Diciembre'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Error! No se ha podido recuperar los días disponibles para agendar una cita.',
        postAppointment: 'Error! No se ha podido agendar la cita seleccionada.',
        postContact: 'Error! No se ha podido solicitar el contacto.'
      }
    }
  }
}
